import { Button } from 'fitify-ui-onboarding/src/components/GenderFunnel/Button/Button'
import { TextInputField } from 'fitify-ui-onboarding/src/components/GenderFunnel/Form/TextInput/TextInputField'
import { ScreenTitle } from 'fitify-ui-onboarding/src/components/GenderFunnel/ScreenTitle/ScreenTitle'
import type { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next/pages'

import { Layout } from 'components/GenderFunnel/Layout/Layout'
import { PageLoader } from 'components/Loader/PageLoader'
import { useRedeemVoucher } from 'sections/redeem/useRedeemVoucher'
import { getCommonStaticProps } from 'utils/get-common-static-props'

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      ...(await getCommonStaticProps(context)),
    },
  }
}

export default function Page() {
  const { t } = useTranslation()
  const { control, form, isLoading, isPageLoading, user } = useRedeemVoucher()

  if (isPageLoading) {
    return <PageLoader />
  }

  return (
    <Layout
      bottomContent={
        <Button
          isDisabled={
            !form.state?.isValid || form.state?.isSubmitting || isLoading
          }
          isLoading={form.state?.isSubmitting || isLoading}
          type="submit"
        >
          {t('common_cta_continue')}
        </Button>
      }
      form={form}
      title={t('redeem_title')}
      user={user}
    >
      <ScreenTitle
        title={t('redeem_title')}
        subtitle={t('redeem_subtitle')}
        align="center"
      />
      <TextInputField
        autoFocus
        control={control}
        label={t('redeem_placeholder')}
        maxLength={8}
        name="voucherCode"
      />
    </Layout>
  )
}
